const forecastDateWidget = {

  async init() {
    dayjs.locale(this.locale);
    this.handleShowForecastButton(false);
    this.initParams();
    const forecastFetcher = this.fetchForecastHashByIdAsync();
    this.initDatePicker();
    this.initEvents();
    this.forecast = await forecastFetcher;
    this.currentPrice = this.forecast['currentPrice'];

    this.handleShowForecastButton(true);
  },

  handleShowForecastButton(show) {
    const showForecastButton = $('#show-forecast-button');

    if (!show) {     
      this.showForecastButtonLabel = showForecastButton.html();
      showForecastButton.html('...');
      showForecastButton.attr('disabled', true);
    }
    else{
      showForecastButton.attr('disabled', false);
      showForecastButton.html(this.showForecastButtonLabel);
    }
  },

  initParams() {
    this.dateNow = new Date();
    const dataset = $('.forecast-date-widget-wrapper')[0].dataset;
    this.currency = dataset.currency;
    this.dateFormat = dataset.dateFormat;
    this.locale = dataset.locale;
    this.coinId = dataset.coinId;
    this.pickerControl = $('#forecast-datepicker');
  },

  async fetchForecastHashByIdAsync() {
    try {

      let response = await fetch(ajaxurl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: new URLSearchParams({
          'action': 'fetchForecastHashById',
          'id': this.coinId
        })
      });

      if (!response.ok) {
        let error = await response.text();
        throw new Error('HTTP status ' + response.status + ': ' + error);
      }

      let result = await response.json();
      return result.data;
    } catch (error) {
      console.error(error);
    }
  },

  initDatePicker() {
    const queryDate = new Date();
    queryDate.setDate(queryDate.getDate() + 1);
    
    this.pickerControl.datepicker({
      dateFormat: this.dateFormat,
      nextText: '',
      prevText: '',
      minDate: 1,
      maxDate: new Date((new Date()).getFullYear() + 4, 11, 31),
      showOtherMonths: true,
      selectOtherMonths: true
    });
    
    $('#ui-datepicker-div').css('display', 'none');    

    this.pickerControl.datepicker('setDate', queryDate);
  },

  initEvents() {
    $('.forecast-date__icon').on('click', () => {
      this.pickerControl.datepicker('show');
    });

    $('.forecast-date-widget-btn button').on('click', (event) => {
      const wrapper = $(event.currentTarget).closest(
        '.forecast-date-widget-wrapper'
      );
      if (!wrapper.hasClass('open')) {
        wrapper.addClass('open');
      }
      this.showForecast();
      $('.forecast-details').css('display', 'block');
    });
  },

  showForecast() {
    this.setCurrentPrice();
    this.setForecastPrice();
    this.setChangeRange();
  },

  beautifyDate(date) {
    return dayjs(date).locale(this.locale).format('DD MMMM YYYY');
  },

  setCurrentPrice() {
    let basePrice = $('#forecastWidgetCurrentPrice');
    let basePriceDate = $('#forecastWidgetCurrentPriceDate span');
    basePrice.html(this.formatNumber(this.currentPrice));

    const beautifiedDate = this.beautifyDate(this.dateNow);
    basePriceDate.html(beautifiedDate);
  },

  setForecastPrice() {
    let basePrice = $('#forecastWidgetForecastPrice');
    let basePriceDate = $('#forecastWidgetForecastPriceDate span');
    const selectedDate = this.getSelectedDate();

    this.averagePrice = this.getAveragePriceByDate(selectedDate);

    basePrice.html(this.formatNumber(this.averagePrice));

    const beautifiedDate = this.beautifyDate(selectedDate);

    basePriceDate.html(beautifiedDate);
  },

  setChangeRange() {
    let changeValue = $('#forecastWidgetChangeValue');

    let diffPrice = this.calculateValueDiff();
    let diffPercent = this.calculaPercentDiff();
    let signAndStyle = this.getSignAndStyle(diffPrice);

    changeValue.html(
      `<span class='${signAndStyle[1]}'>${signAndStyle[0]}${this.formatNumber(
        diffPrice
      )} / ${signAndStyle[0]}${this.formatPercent(diffPercent)}%</span>`
    );
  },

  getSelectedDate() {
    return this.pickerControl.datepicker('getDate');
  },

  getAveragePriceByDate(date) {
    return this.forecast[dayjs(date).format('YYYY-MM-DD[T]12:00:00[Z]')];
  },

  calculateValueDiff() {
    return this.averagePrice - this.currentPrice;
  },

  calculaPercentDiff() {
    return (this.averagePrice / this.currentPrice - 1) * 100;
  },

  getSignAndStyle(value) {
    let sign = '';
    let style = 'red';

    if (value >= 0) {
      sign = '+';
      style = 'green';
    }

    return [sign, style];
  },

  formatNumber(value) {
    value = parseFloat(value);
    return new Intl.NumberFormat(this.locale, {
      style: 'currency',
      currency: this.currency,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: this.getFloatPoints(value),
    }).format(value);
  },

  formatPercent(value) {
    value = parseFloat(value);
    return new Intl.NumberFormat(this.locale, {
      maximumFractionDigits: this.getPercentsPoints(value),
    }).format(value);
  },

  getPercentsPoints(diffPercent) {
    let fixedDigitsPercent = 2;

    if (diffPercent >= 0.0 && diffPercent <= 1.0) {
      fixedDigitsPercent = 4;
    }

    return fixedDigitsPercent;
  },

  getFloatPoints(value) {
    value = Math.abs(value);

    if (value < 0.00000000005) {
      return 15;
    }

    if (value < 0.000000005) {
      return 13;
    }

    if (value < 0.0000005) {
      return 11;
    }

    if (value < 0.00005) {
      return 9;
    }

    if (value < 0.005) {
      return 7;
    }

    if (value < 0.05) {
      return 6;
    }

    if (value < 0.5) {
      return 5;
    }

    if (value < 1) {
      return 4;
    }

    if (value < 5) {
      return 3;
    }

    if (value > 100000) {
      return 0;
    }

    return 2;
  },
};

export default forecastDateWidget;
